/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback } from 'react';
import clsx from 'clsx';
import { string, bool, func, oneOfType, number } from 'prop-types';
import { Tooltip } from '@nextiva/next-ui-components';

import { SvgCheckboxChecked } from 'components/SvgIcon';

export const Item = ({
  selected,
  text,
  onClick,
  id,
  disabled,
  tooltipMessage,
  item,
  'data-testid': dataTestId,
}) => {
  const displayedName = () => {
    if (item.hasOwnProperty('description') && text.includes('NUC-')) {
      return item?.description;
    }
    return text;
  };

  const clicked = useCallback(() => {
    if (disabled) return;
    onClick(id);
  });

  return (
    <Tooltip
      placement="top"
      title={disabled && tooltipMessage ? tooltipMessage : ''}
      data-testid={dataTestId}
    >
      <div
        onClick={clicked}
        className={clsx(
          selected
            ? 'm-multiselect-search__list__item--selected'
            : 'm-multiselect-search__list__item',
          disabled && 'm-multiselect-search__list__item--disabled',
        )}
        data-testid={`PlatformAdminUI-UsersLink-MultiSelectSearch-ListItem-${selected}`}
      >
        <span
          className={clsx(
            'Body',
            selected
              ? 'm-multiselect-search__list__item__text--selected'
              : 'm-multiselect-search__list__item__text',
          )}
          data-testid={`PlatformAdminUI-UsersLink-MultiSelectSearch-ListItemText-${selected}`}
        >
          {displayedName()}
        </span>
        {selected && <SvgCheckboxChecked />}
      </div>
    </Tooltip>
  );
};

Item.propTypes = {
  id: oneOfType([string, number]).isRequired,
  text: string.isRequired,
  onClick: func.isRequired,
  selected: oneOfType([bool, func]),
};

Item.defaultProps = {
  selected: false,
};
